import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import useSmoothScroll from "@/hooks/useSmoothScroll";
import { AuthProvider } from "@/lib/authClient";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import ServiceDetail from "@/pages/ServiceDetail";
import AdminLogin from "@/pages/admin/AdminLogin";
import ForgotPassword from "@/pages/admin/ForgotPassword";
import ResetPassword from "@/pages/admin/ResetPassword";
import AdminInbox from "@/pages/admin/AdminInbox";

function App() {
  useSmoothScroll();

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminInbox />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
